import script from "./UserComment.vue?vue&type=script&setup=true&lang=js"
export * from "./UserComment.vue?vue&type=script&setup=true&lang=js"

import "./UserComment.vue?vue&type=style&index=0&id=79e757a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e757a8"]])

export default __exports__